import { useQuery } from '@apollo/client/react';
import { initApolloClient } from '@drycut/apollo';
import { type BasicStoreFragment, GetStoreDocument, GetStoresDocument } from '@drycut/graphql';
import { Select, type SelectOption } from '@drycut/ui-components';

import { useCheckoutStore } from '../../checkoutStore';

export function SalonSelect(): React.ReactElement {
  const { data } = useQuery(GetStoresDocument);
  const selectedStore = useCheckoutStore((state) => state.selectedStore);

  const stores = data?.stores?.nodes || [];
  const validStores = stores.filter((node): node is BasicStoreFragment => Boolean(node));

  const handleChange = async (option: null | SelectOption) => {
    const client = initApolloClient();

    const { data } = await client.query({
      query: GetStoreDocument,
      variables: { slug: option?.value ?? '' },
    });

    const store = data?.store ?? null;

    useCheckoutStore.setState({
      selectedStore: store,
      selectedSchedule: undefined,
      scheduled: false,
    });
  };

  const options = validStores.map((store) => ({
    id: store.id,
    label: store.name,
    value: store.slug,
  }));

  return (
    <Select
      options={options}
      selected={options.find((option) => option.value === selectedStore?.slug) || null}
      onChange={handleChange}
      prompt="Salon auswählen"
    />
  );
}
